// extracted by mini-css-extract-plugin
export default {"titleName":"EditAffiliateModal_titleName__29b6W"};